/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * WebhookTestResultDtoBase
 * auto generated base class for the model WebhookTestResultDtoModel.
 */
export const WebhookTestResultDtoModelBase = ModelBase
  .named('WebhookTestResultDto')
  .props({
    __typename: types.optional(types.literal("WebhookTestResultDto"), "WebhookTestResultDto"),
    success: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WebhookTestResultDtoModelSelector extends QueryBuilder {
  get success() { return this.__attr(`success`) }
}
export function selectFromWebhookTestResultDto() {
  return new WebhookTestResultDtoModelSelector()
}

export const webhookTestResultDtoModelPrimitives = selectFromWebhookTestResultDto().success
